import moment from 'helpers/moment'
import clsx from 'clsx'
import React, {useContext} from 'react'
import {useHistory, useLocation} from 'react-router-dom'
import {makeStyles} from 'external/material'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableSortLabel from '@mui/material/TableSortLabel'

import {TeacherContext} from 'teacher/context'

const useStyles = makeStyles(studentAnsweredAssessmentsHeadStyles)

const headCells = [
  { id: 'date', align: 'left', disablePadding: false},
  { id: 'title', align: 'left', disablePadding: false},
  { id: 'period', align: 'left', disablePadding: false},
  { id: 'type', align: 'left', disablePadding: false},  
  { id: 'total', align: 'center', disablePadding: false},
  { id: 'points', align: 'center', disablePadding: false},
  { id: 'grade', align: 'center', disablePadding: false}
];

export default function GradesHead(props) {

  const classes = useStyles()
  const history = useHistory()
  const context = useContext(TeacherContext)
  const location = useLocation()

  const {query, translate, linkQuery} = context
  const order = query.orderBy ? (query.orderBy.startsWith('-') ? 'desc' : 'asc') : undefined
  const orderBy = order ? (order == 'asc' ? query.orderBy : query.orderBy.substring(1)) : undefined

  const createSortHandler = (property) => (event) => {
    history.push(linkQuery(location.pathname,
      {...query, orderBy: `${orderBy == property && order == 'asc' ? '-' : ''}${property}`}
    ))
  }

  return (
    <TableHead>
      <TableRow className={classes.headersRow}>
        {headCells.map(({id, align, disablePadding}) => (
          <TableCell
            key={id}
            padding={disablePadding ? 'none' : 'normal'}
            className={classes.headerCell}
            sortDirection={order}
            onClick={createSortHandler(id)}
            style={{top:92}}
          >
            <TableSortLabel
              className={clsx(classes.headerLabel, align)}
              active={orderBy === id}
              direction={order}
            >
              {translate(`${id}-student-answered-assessment-header`)}
              {orderBy === id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell className={classes.filler} style={{top:92}} align="right" />
      </TableRow>
    </TableHead>
  )
}

function studentAnsweredAssessmentsHeadStyles() {
  return {
    headersRow: {
      color: '#50566e',
      '& > th': {
        backgroundColor: '#f1faff'
      }
    },
    headerCell: {
      padding: 0,
      paddingLeft: 16,
      color: '#4f576e',
      borderLeft: 'solid 1px #d8dbe0',
      borderRight: 'solid 1px #d8dbe0',
      '&:first-child': {
        borderLeft: 0
      },
      "& .label": {
        padding: '0 10px',
        textAlign: 'center'
      },
      "&.filler": {
        borderLeft: 'solid 1px #d8dbe0',
        width: 0,
        padding: 0,
      },
    },
    headerLabel: {
      color: '#4f576e',
      fontWeight: 'bold',
      '&.center': {
        display: 'flex',
        justifyContent: 'center',
      }
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
  }
}
